import React from 'react'
import {
  Modal,
  Icon,
  LabelValue,
  // @ts-ignore next
} from '@adc/ui-morpheus'
import type { LookupNotification } from '@adc/sdk/types'
import classnames from 'classnames/bind'
import styles from './styles.scss'
import { NotificationReportGraph } from './notificationReportGraph'

const cx = classnames.bind(styles)

interface CommunicationDetailModalProps {
  onClose: () => void
  communicationData: LookupNotification | null
}

const CommunicationDetailModal: React.FC<CommunicationDetailModalProps> = ({
  onClose,
  communicationData,
}): React.ReactElement => {
  return (
    <Modal
      open
      onClose={onClose}
      size='fullscreen'
      elmId='communication_detail_modal'
      closeIcon={
        <Icon
          className='close'
          data-elm-id='communication_detail_modal_close_button'
          name='times'
          iconStyle='regular'
          fitted
          onClick={onClose}
        />
      }
      className={cx('modal')}
    >
      <Modal.Content>
        <div className={cx('modal-content')}>
          <div className={cx('detail-container')}>
            <LabelValue
              label='Name'
              elmId={'communication_detail_modal_notification_name'}
              value={communicationData?.notification_display_name}
            />
            <LabelValue
              label='Line of Business'
              elmId={'communication_detail_modal_channel'}
              value={communicationData?.asset_type}
            />
            <LabelValue
              label='Channel'
              elmId={'communication_detail_modal_channel'}
              value={communicationData?.config?.[0]?.channel}
            />
            <LabelValue
              label='Is Active'
              elmId={'communication_detail_modal_is_active'}
              value={communicationData?.config?.[0]?.is_active ? 'Yes' : 'No'}
            />
          </div>
          <NotificationReportGraph
            notificationId={communicationData?.notification_id}
          />
        </div>
      </Modal.Content>
    </Modal>
  )
}

export default CommunicationDetailModal
